import React from 'react';
import PropTypes from 'prop-types';
import { StyledTitle } from './style';

const TitleGivens = ({ className, title }) => (
  <StyledTitle className={className}>{title}</StyledTitle>
);

TitleGivens.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string
};

export default TitleGivens;
